var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Messaging")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "item-detail item-detail-simple" },
      _vm._l(_vm.threads, function (thread) {
        return _c("booking-thread-list-item", {
          key: thread.id,
          attrs: { thread: thread, booking: _vm.booking },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }